<template>
  <div v-if="isLoading" class="dialog-spinner py-5 white">
    <v-progress-circular indeterminate size="50" color="primary"></v-progress-circular>
  </div>
  <RoleInVesselForm
    v-else-if="item"
    :handle-submit="onSendForm"
    :handle-update-field="updateField"
    :values="item"
    :errors="violations"
    :vessel="vessel"
    @close="$emit('close')"
  ></RoleInVesselForm>
</template>

<script>
import RoleInVesselForm from './Form'
import { mapActions, mapGetters } from 'vuex'

export default {
  components: {
    RoleInVesselForm
  },

  props: {
    vessel: {
      type: Object,
      required: false,
      default: null
    }
  },

  data() {
    return {
      item: {
        vessel: this.vessel['@id']
      }
    }
  },

  computed: {
    ...mapGetters({
      isLoading: 'roleinvessel/create/isLoading',
      error: 'roleinvessel/create/error',
      created: 'roleinvessel/create/created',
      violations: 'roleinvessel/create/violations'
    })
  },

  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    created: function(created) {
      if (!created) {
        return
      }
      if (this.vessel) {
        this.getRoleInVessels('/role_in_vessels?pagination=false&vessel=' + this.vessel['@id'])
      }

      this.$emit('close')
    }
  },

  methods: {
    ...mapActions({
      create: 'roleinvessel/create/create',
      getRoleInVessels: 'roleinvessel/list/default'
    }),

    onSendForm(item) {
      this.create(item)
    },

    updateField(field, value) {
      Object.assign(this.item, { [field]: value })
    }
  }
}
</script>
